<template>
    <div
        class="fixed mlg:hidden top-0 left-0 height-fix w-screen z-40 transition-all"
        :class="{'visible' : show, 'invisible': !show}"
    >
        <div
            class="absolute h-full w-full  bg-darkblue-800 duration-500 transition-all"
            :class="{ 'opacity-50' : show , 'opacity-0' : !show}"
            @click="$emit('close')"
        ></div>
        <div
            class="absolute transform-gpu w-full h-[calc(var(--vh,1vh)*100-max(91px,7%))] transition-all duration-500"
            :class="{'bottom-0' : show , '-bottom-full' : !show }"
        >
            <div class="h-full">
                <div class="h-full overflow-hidden px-5 pb-5" :class="background" >
                    <h2
                        class="flex items-center align-baseline pt-5 pb-4 font-bold cursor-pointer border-b border-solid border-darkblue"
                        @click="$emit('close')"
                    >
                        <button class="btn btn--primary w-10 h-10 !rounded-full mr-4">
                            <icon-arrow class="!w-1.5"/>
                        </button>
                        
                        <span class="font-extrabold text-darkblue text-[16px] leading-[1.5] tracking-[0.45px]">{{ title }}</span>
                    </h2>
                    
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import IconArrow from "./Icons/IconArrow";
import Separator from "./helpers/Separator";

export default {
    name: "OrderSummaryPopup",
    components: { Separator, IconArrow },
    props: {
        isMobile: {},
        show: {},
        title: {},
        selected: {},
        options: {},
        background: {
            default: 'bg-white'
        }
    },
    watch: {
        show(newValue) {
            if ( newValue ) {
                document.body.classList.add("overflow-hidden");
            }
            else {
                document.body.classList.remove("overflow-hidden");
            }
        }
    }
}
</script>